import { actionTypes } from '../actioncreators/actioncreators'

export const QuestionsReducer = (currentState = [], action) => {
  let nextState
  switch (action.type) {
    case actionTypes.ADD_QUESTION:
      nextState = [
        ...currentState,
        {
          id: action.id,
          text: ''
        }
      ]
      return nextState
    case actionTypes.CHANGE_QUESTION:
      nextState = [ ...currentState ]
      nextState.find(x => x.id === action.id).text = action.value
      return nextState
    case actionTypes.DELETE_QUESTION:
      return currentState.filter((item, index) => item.id !== action.id)
    case actionTypes.LOAD_EXAMPLE_MAP:
      return action.data.questions
    default:
      return currentState
  }
}

export default QuestionsReducer
